import moment, { tz } from 'moment-timezone';

export const getTimezoneOption = (timezone: string) => ({
    key: timezone,
    name: timezone,
    value: `${timezone} (GMT ${tz(timezone).format('Z')})`,
  });

export const convertSameLocalTimeToDifferentTimezone = (
  isoString: string,
  originalTimezone: string,
  targetTimezone: string,
) => {
  // Parse the date as if it's in the original timezone
  const dateInOriginalTZ = moment.tz(isoString, originalTimezone);

  // Convert to target timezone while keeping the same local time
  const dateInTargetTZ = moment.tz(
    dateInOriginalTZ.format('YYYY-MM-DDTHH:mm:ss'),
    targetTimezone,
  );

  // Return the ISO string in the target timezone
  return dateInTargetTZ.toISOString();
};
